import React, { useEffect, useRef } from 'react'
import playAnimation from 'animations/play-animation.json'
import lottie from 'lottie-web'
import { LottieContainer } from './LottieAnimation.styles'

const LottieAnimation = ({
  animationData = playAnimation,
  loop = true,
  autoplay = true,
  style
}) => {
  const containerRef = useRef(null)

  useEffect(() => {
    const animationInstance = lottie.loadAnimation({
      container: containerRef.current,
      renderer: 'svg',
      loop,
      autoplay,
      animationData
    })

    return () => {
      animationInstance.destroy()
    }
  }, [animationData, loop, autoplay])

  return <LottieContainer ref={containerRef} style={style}></LottieContainer>
}

export default LottieAnimation
